import { Box } from '@rbilabs/universal-components';

export const PspErrorIconBox = Box.withConfig<{
  $isNative: boolean;
}>(p => ({
  marginBottom: p.$isNative ? '$4' : '1',
  flex: 1,
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const PspErrorTitleBox = Box.withConfig<{
  $isNative: boolean;
}>(p => ({
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: p.$isNative ? '4' : '2',
}));
